import { apiWrapper } from '@/services/api/apiWrapper'

export interface SystemAvailabilityResponse {
	isSystemAvailable: boolean
	validationErrors: string[]
}

export const getSystemAvailability = async () => {
	const response = await apiWrapper({
		url: `/member/myblueprint/v1/public/systemavailability`,
		method: 'GET',
		errorCode: 'BP-NFA-009'
	})
	return response.json() as Promise<SystemAvailabilityResponse>
}
